import { cva, type VariantProps } from 'class-variance-authority'
import type { LucideIcon } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { cn } from '../../lib/utils'

const navItemVariants = cva('flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition', {
  variants: {
    active: {
      // 选中：主色反色块 + 深色文字，高对比一眼可见
      true: 'bg-primary text-[#04121a] font-medium shadow-[0_0_16px_var(--primary-soft,rgba(86,215,255,.25))]',
      false: 'text-muted-foreground hover:bg-foreground/[.04] hover:text-foreground',
    },
  },
  defaultVariants: { active: false },
})

export type NavItemProps = {
  to: string
  icon: LucideIcon
  label: string
  trailing?: React.ReactNode
  className?: string
} & VariantProps<typeof navItemVariants>

/** 侧栏导航项：选中态由路由自动判定 */
export function NavItem({ to, icon: Icon, label, trailing, className }: NavItemProps) {
  return (
    <NavLink to={to} className={({ isActive }) => cn(navItemVariants({ active: isActive }), className)}>
      <Icon size={16} strokeWidth={1.8} />
      <span className="flex-1">{label}</span>
      {trailing}
    </NavLink>
  )
}
